import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Building, Users, TrendingUp, Plus } from 'lucide-react';
export function LandlordDashboard() {
  return <DashboardLayout userType="landlord" data-id="element-759" data-mp="uaiw5biz1m07">
      <div className="flex justify-between items-center mb-8" data-id="element-760" data-mp="1rwomunij48h0">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-761" data-mp="1rxzlya114s1s">Property Overview</h2>
        <Button data-id="element-762" data-mp="1mxvflctu5dpa">
          <Plus className="w-4 h-4 mr-2" data-id="element-763" data-mp="1mzg1ke233obj" />
          Add Property
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-764" data-mp="1i4airo3zapro">
        <Card data-id="element-765" data-mp="1d6h8aivn79ll">
          <CardContent className="p-6" data-id="element-766" data-mp="1d70j7fmvkxq4">
            <div className="flex justify-between items-start mb-4" data-id="element-767" data-mp="2ameg366n8m6t">
              <div className="bg-amber-100 p-2 rounded-lg text-amber-600" data-id="element-768" data-mp="2aor5g4eqdytw">
                <Building className="w-6 h-6" data-id="element-769" data-mp="25ud6xt4rvbl0" />
              </div>
              <Badge variant="success" data-id="element-770" data-mp="3fba3mxku2oar">+12%</Badge>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-771" data-mp="3jd42d0bgxi8a">4</div>
            <div className="text-slate-500 text-sm" data-id="element-772" data-mp="3jcc41hqhl6eb">Active Properties</div>
          </CardContent>
        </Card>

        <Card data-id="element-773" data-mp="35jwad7jh6kq2">
          <CardContent className="p-6" data-id="element-774" data-mp="3akto97xgcslr">
            <div className="flex justify-between items-start mb-4" data-id="element-775" data-mp="3ajinzi37u2ze">
              <div className="bg-indigo-100 p-2 rounded-lg text-indigo-600" data-id="element-776" data-mp="2vn1det2uosdw">
                <Users className="w-6 h-6" data-id="element-777" data-mp="2vpvucamnnv2k" />
              </div>
              <Badge variant="success" data-id="element-778" data-mp="30o764qwigfnf">98%</Badge>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-779" data-mp="2mnmovz68urw1">42</div>
            <div className="text-slate-500 text-sm" data-id="element-780" data-mp="2rlxufxpiag8g">Total Tenants</div>
          </CardContent>
        </Card>

        <Card data-id="element-781" data-mp="kvri9xyuhdko">
          <CardContent className="p-6" data-id="element-782" data-mp="kv89p7v341jb">
            <div className="flex justify-between items-start mb-4" data-id="element-783" data-mp="kw9nvl7ed459">
              <div className="bg-emerald-100 p-2 rounded-lg text-emerald-600" data-id="element-784" data-mp="ptjfn7i9drw9">
                <TrendingUp className="w-6 h-6" data-id="element-785" data-mp="ngfqnpk9yok8" />
              </div>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-786" data-mp="jeknefisa13t">₦12.5M</div>
            <div className="text-slate-500 text-sm" data-id="element-787" data-mp="jgp11p6hieha">Annual Revenue</div>
          </CardContent>
        </Card>
      </div>

      <Card className="mb-8" data-id="element-788" data-mp="9geq6b7x9j5a">
        <CardHeader data-id="element-789" data-mp="9hgbd8injm0q">
          <CardTitle data-id="element-790" data-mp="9hzgtpr48hxv">Active Listings</CardTitle>
        </CardHeader>
        <div className="overflow-x-auto" data-id="element-791" data-mp="172vhmztz52j4">
          <table className="w-full text-sm text-left" data-id="element-792" data-mp="175zs2ey18ui8">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-793" data-mp="125vdwvklkbv6">
              <tr data-id="element-794" data-mp="xd2804de6xhi">
                <th className="px-6 py-4" data-id="element-795" data-mp="xcj2jn4xi1kd">Property Name</th>
                <th className="px-6 py-4" data-id="element-796" data-mp="sfiwhc82wyt9">Location</th>
                <th className="px-6 py-4" data-id="element-797" data-mp="scwo5add6f9z">Occupancy</th>
                <th className="px-6 py-4" data-id="element-798" data-mp="1puofb7jznbx6">Status</th>
                <th className="px-6 py-4" data-id="element-799" data-mp="1pw7u0tpzxewu">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-800" data-mp="1l1lhgn86hgb6">
              {[{
              name: 'Emerald Heights',
              loc: 'Unilag, Akoka',
              occ: '12/12',
              status: 'Full'
            }, {
              name: 'Sunshine Lodge',
              loc: 'Yaba Tech',
              occ: '8/10',
              status: 'Available'
            }, {
              name: 'The Haven',
              loc: 'Bariga',
              occ: '15/20',
              status: 'Available'
            }].map((prop, idx) => <tr key={idx} className="hover:bg-slate-50" data-id="element-801" data-mp="2l4jlfvx1t8gx" data-mpi={idx}>
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-802" data-mp="2q2blxebre2wq">
                    {prop.name}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-803" data-mp="2v2pio07wtqfg">{prop.loc}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-804" data-mp="2z2zys5pf1x81">{prop.occ}</td>
                  <td className="px-6 py-4" data-id="element-805" data-mp="2z0wzsw6actr6">
                    <Badge variant={prop.status === 'Full' ? 'success' : 'warning'} data-id="element-806" data-mp="lymk8wb2461">
                      {prop.status}
                    </Badge>
                  </td>
                  <td className="px-6 py-4" data-id="element-807" data-mp="9ds7s8ms431y">
                    <Button variant="ghost" size="sm" className="text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50" data-id="element-808" data-mp="9gwmhzxveh6v">
                      Manage
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </DashboardLayout>;
}